export default __webpack_public_path__ + "static/media/bloom.a0580997.png";